/* eslint-disable max-lines */
import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useTranslate } from '@im/react-localization';
import UpdateIcon from '@mui/icons-material/Update';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { EMEA_COUNTRY_CODES } from './common.types';

type PropTypes = {
  ShowCentralStockTtypeSku?: boolean;
  fromPage: string;
  productType?: string;
  siteCode: string;
  warehouseStockDetailUpdate: any;
};

const WarehouseEMEAGridData = (props: PropTypes) => {
  const translate = useTranslate();
  const makeBold = (item: any, keyword: any) => {
    const re = new RegExp(keyword, 'g');
    return item.replace(re, `<b>${keyword}</b>`);
  };

  function checkfunctionTrue(ShowCentralStockTtypeSku: any, name: any) {
    return ShowCentralStockTtypeSku === true && name?.toUpperCase() === 'LOCAL';
  }

  function checkfunctionFalse(ShowCentralStockTtypeSku: any, name: any) {
    return (
      ShowCentralStockTtypeSku === false && name?.toUpperCase() === 'LOCAL'
    );
  }

  function checkCentralType(name: any, productType: any) {
    return (
      name?.toUpperCase() === 'CENTRAL' && productType?.toUpperCase() === 'T'
    );
  }

  function QtyCheckLocalCental(quantityAvailable: any) {
    return quantityAvailable > 0;
  }

  return (
    <>
      <WarehouseDetailsBody container>
        <Grid
          container
          sx={{ alignContent: 'flex-start', display: 'flex', flex: 1 }}
        >
          <WarehouseTableHeader container>
            <Grid item xs={3}>
              {translate('Common.Stock')}
            </Grid>
            <Grid item xs={3}>
              {translate('Checkout.Shipment')}
            </Grid>
            <Grid item xs={3}>
              {translate('Common.OnOrder')}
            </Grid>
            <Grid item xs={3}>
              {translate('Common.LeadTimeETA')}
            </Grid>
          </WarehouseTableHeader>
          <Box sx={{ height: '300px', overflow: 'auto', width: '100%' }}>
            <Grid container sx={{ paddingLeft: '0rem' }}>
              {props.warehouseStockDetailUpdate?.map(
                (warehouse: any, i: number) =>
                  warehouse.name?.toUpperCase() === 'LOCAL' &&
                  (warehouse.productType?.toUpperCase() === 'J' ||
                    warehouse.productType?.toUpperCase() === 'W') &&
                  warehouse.quantityAvailable <= 0 ? (
                    ''
                  ) : (
                    <>
                      <Grid
                        container
                        key={i}
                        sx={{
                          borderBottom: 1,
                          borderBottomColor: '#C4C4C4',
                          p: 1.5,
                        }}
                      >
                        <Grid item pl={1} xs={3}>
                          {warehouse.quantityAvailable || 0}
                        </Grid>

                        <Grid item xs={3}>
                          <Typography title={warehouse.name || ''}>
                            <IconContainer
                              component="p"
                              sx={{ marginTop: '0px' }}
                            >
                              {(warehouse.name?.toUpperCase() ===
                                'NOTAVAILABLE' ||
                                warehouse.id?.toUpperCase() === 'RESERVED') && (
                                <>
                                  <ReservedIcon component="span">
                                    R
                                  </ReservedIcon>{' '}
                                  &nbsp;
                                  {translate('Common.Reserved')}
                                </>
                              )}
                              {checkfunctionTrue(
                                props.ShowCentralStockTtypeSku,
                                warehouse.name
                              ) &&
                              QtyCheckLocalCental(
                                warehouse.quantityAvailable
                              ) ? (
                                <>
                                  <LocationOnOutlinedIcon></LocationOnOutlinedIcon>{' '}
                                  &nbsp;
                                  {translate('Warehouse.LocalShipmentText')}
                                </>
                              ) : (
                                ''
                              )}

                              {checkfunctionFalse(
                                props.ShowCentralStockTtypeSku,
                                warehouse.name
                              ) && (
                                <>
                                  <LocationOnOutlinedIcon></LocationOnOutlinedIcon>{' '}
                                  &nbsp;
                                  {translate('Warehouse.LocalShipmentText')}
                                </>
                              )}
                              {/* eslint-disable-next-line no-nested-ternary */}
                              {props.ShowCentralStockTtypeSku === false ? (
                                checkCentralType(
                                  warehouse.name,
                                  props.productType
                                ) ? (
                                  <>
                                    <UpdateIcon></UpdateIcon> &nbsp;
                                    {translate('Warehouse.CentrlShipmentText2')}
                                  </>
                                ) : (
                                  warehouse.name?.toUpperCase() ===
                                    'CENTRAL' && (
                                    <>
                                      <>
                                        <UpdateIcon></UpdateIcon> &nbsp;
                                        {translate(
                                          'Warehouse.CentrlShipmentText'
                                        )}
                                      </>
                                    </>
                                  )
                                )
                              ) : (
                                ''
                              )}
                              {/* eslint-disable-next-line no-nested-ternary */}
                              {props.ShowCentralStockTtypeSku === true
                                ? checkCentralType(
                                    warehouse.name,
                                    props.productType
                                  )
                                  ? [
                                      QtyCheckLocalCental(
                                        warehouse.quantityAvailable
                                      ) ? (
                                        <>
                                          <UpdateIcon></UpdateIcon> &nbsp;
                                          {translate(
                                            'Warehouse.CentrlShipmentText2'
                                          )}
                                        </>
                                      ) : (
                                        [
                                          QtyCheckLocalCental(
                                            warehouse.quantityAvailable
                                          )
                                            ? ''
                                            : '-',
                                        ]
                                      ),
                                    ]
                                  : [
                                      warehouse.name?.toUpperCase() ===
                                        'CENTRAL' &&
                                      QtyCheckLocalCental(
                                        warehouse.quantityAvailable
                                      ) ? (
                                        <>
                                          <>
                                            <UpdateIcon></UpdateIcon> &nbsp;
                                            {translate(
                                              'Warehouse.CentrlShipmentText'
                                            )}
                                          </>
                                        </>
                                      ) : (
                                        [
                                          QtyCheckLocalCental(
                                            warehouse.quantityAvailable
                                          )
                                            ? ''
                                            : '-',
                                        ]
                                      ),
                                    ]
                                : ''}

                              {warehouse.name?.toUpperCase() ===
                                'VENDOR WAREHOUSE**' && <>{warehouse.name}</>}
                            </IconContainer>
                          </Typography>
                        </Grid>
                        {EMEA_COUNTRY_CODES.includes(
                          props.siteCode?.toUpperCase()
                        ) &&
                        warehouse?.quantityOnOrder &&
                        warehouse?.quantityOnOrder?.length > 0 ? (
                          <>
                            <Grid item pl={2} xs={3}>
                              {warehouse.quantityOnOrder || 0}
                            </Grid>
                            <Grid item pl={2} xs={3}>
                              {warehouse.quantityOnOrderEta || '-'}
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid item pl={2} xs={3}>
                              {warehouse.onOrderQuantity || 0}
                            </Grid>
                            <Grid item pl={2} xs={3}>
                              {warehouse.estimatedLeadTime || '-'}
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </>
                  )
              )}
            </Grid>
          </Box>
        </Grid>
        <Grid container mt={2} rowSpacing={1}>
          <Grid item xs={12}>
            {props.siteCode?.toUpperCase() === 'GB' ? (
              <pre style={{ margin: '0px' }}>
                <Typography component="span" fontWeight="bold">
                  {translate('Common.Leadtime')}
                  {props.fromPage === 'cart' ? '*' : ''} :{' '}
                  <Typography
                    component="span"
                    dangerouslySetInnerHTML={{
                      __html: makeBold(
                        translate('Product.Warehouseorderplacedmsg'),
                        'On Order :'
                      ),
                    }}
                  ></Typography>
                </Typography>
              </pre>
            ) : (
              <Typography component="span" fontWeight="bold">
                {translate('Common.Leadtime')}
                {props.fromPage === 'cart' ? '*' : ''} :{' '}
                <Typography component="span">
                  {translate('Product.Warehouseorderplacedmsg')}
                </Typography>
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography component="span" fontWeight="bold">
              {translate('Common.ETAInfo_Heading')}
              {props.fromPage === 'cart' ? '*' : ''}:{' '}
            </Typography>
            <Typography component="span">
              {translate('Product.Warehouseorderconfirmationmsg')}
            </Typography>
          </Grid>
        </Grid>
      </WarehouseDetailsBody>
    </>
  );
};

export default WarehouseEMEAGridData;

const IconContainer = styled(Box)(() => ({
  alignItems: '',
  display: 'flex',
  flexDirection: 'row',
  marginRight: '10px',
}));

const WarehouseDetailsBody = styled(Grid)(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'space-between',
  typography: 'body1',
  width: '100%',
}));

const WarehouseTableHeader = styled(Grid)(({ theme }) => ({
  '& .MuiGrid-item': { alignItems: 'flex-end', display: 'flex' },
  backgroundColor: '#F8F8F8',
  borderBottom: 'solid 2px #0077D4',
  display: 'flex',
  flexWrap: 'nowrap',
  fontSize: '14px',
  fontWeight: 'bold',
  padding: theme.spacing(3, 1.5, 0.5),
}));

const ReservedIcon = styled(Box)(() => ({
  alignItems: 'center',
  backgroundColor: '#18846F',
  borderRadius: '50%',
  color: 'white',
  display: 'inline-flex',
  height: 24,
  justifyContent: 'center',
  width: 24,
}));
